// extracted by mini-css-extract-plugin
export default {"hiddenButton":"styles_hiddenButton__a7N5i"};